import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-info-button-icon',
  templateUrl: './info-button-icon.component.html',
  styleUrls: ['./info-button-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoButtonIconComponent {}
